import React, { lazy } from "react";
import { useRoutes } from "react-router-dom";

//layouts
import FullLayout from "@/layouts/full/FullLayout";
import CreateLayout from "@/layouts/create/CreateLayout";
import LandingLayout from "@/layouts/landing/LandingLayout";
import BlankLayout from "@/layouts/blank/BlankLayout";
import AccountSettings from "./pages/account-settings";

//hoc
import withAuth from "@/hoc/withAuth";

//pages
const LoginPage = React.lazy(() => import("@/pages/login"));
const ResetPassword = React.lazy(() => import("@/pages/reset-password"));
const EmailOTP = React.lazy(() => import("@/pages/email-otp"));
const MobileOTP = React.lazy(() => import("@/pages/mobile-otp"));
const ForgetPassword = React.lazy(() => import("@/pages/forget-password"));
const Authenticator = React.lazy(() => import("@/pages/authenticator"));
const LandingPage = React.lazy(() => import("@/pages/landing"));
const UnauthorizedPage = React.lazy(() => import("@/pages/unauthorized"));
const VerifyEmail = React.lazy(() => import("@/pages/verify-email"));
// XSM-1536 - SSO Feature
// Author: Abhishek Bharti
const Dashboard = withAuth(lazy(() => import("@/pages/dashboard")));
const DomainManagement = withAuth(lazy(() => import("@/pages/domain-management")));
const AdminDomainManagement = withAuth(lazy(() => import("@/pages/admin-domain-management")));
const OrganizationManagement = withAuth(lazy(() => import("@/pages/organization-management")));
const PermissionManagement = withAuth(lazy(() => import("@/pages/permission-management")));
const RoleManagement = withAuth(lazy(() => import("@/pages/role-management")));
const UserAndGroupManagement = withAuth(lazy(() => import("@/pages/users-and-groups")));
const CreateGroup = withAuth(lazy(() => import("@/pages/users-and-groups/create-groups")));
const CreateUser = withAuth(lazy(() => import("@/pages/users-and-groups/create-users")));
const ApplicationManagement = withAuth(lazy(() => import("@/pages/application-management")));
const AdvancedAPIManagement = withAuth(lazy(() => import("@/pages/advanced-api-management")));
const AuthenticationSettings = withAuth(lazy(() => import("@/pages/authentication-settings")));
const DomainSetup = withAuth(lazy(() => import("@/pages/domain-setup")));
const AdvancedDomainSetup = withAuth(lazy(() => import("@/pages/adv-domain-setup")));
const ProductPage = withAuth(lazy(() => import("@/pages/product-page")));
const ApplicationCreationPage = withAuth(lazy(() => import("@/pages/application-creation")));
const EntitiesPage = withAuth(lazy(() => import("@/pages/entites")));
const CreateEntityPage = withAuth(lazy(() => import("@/pages/entites/create-entity")));
const MappingManagementPage = withAuth(lazy(() => import("@/pages/mapping-management")));
const CreateMappingPage = withAuth(lazy(() => import("@/pages/mapping-management/resources")));
const CreateDomain = withAuth(lazy(() => import("@/pages/admin-domain-management/create-domain")));

export default function Router() {
  const routes = useRoutes([
    {
      path: "/dashboard",
      element: <FullLayout />,
      children: [
        {
          path: "",
          element: <Dashboard />,
          index: true
        },
        {
          path: "application-creation",
          element: <ApplicationCreationPage />
        },
        {
          path: "entities",
          children: [
            {
              path: "",
              element: <EntitiesPage />,
              index: true
            },
            {
              path: "create-entity",
              element: <CreateEntityPage />
            }
          ]
        },
        {
          path: "mapping-management",
          children: [
            {
              path: "",
              element: <MappingManagementPage />,
              index: true
            },
            {
              path: "resources",
              element: <CreateMappingPage />
            }
          ]
        },
        {
          path: "admin-domain-management",
          children: [
            {
              path: "",
              element: <AdminDomainManagement />,
              index: true
            },
            {
              path: "create-domain",
              element: <CreateDomain />
            }
          ]
        },
        { path: "domain-management", element: <DomainManagement /> },
        { path: "organization-management", element: <OrganizationManagement /> },
        { path: "permission-management", element: <PermissionManagement /> },
        { path: "role-management", element: <RoleManagement /> },
        {
          path: "users-and-groups",
          children: [
            {
              path: "",
              element: <UserAndGroupManagement />,
              index: true
            },
            {
              path: "create-groups",
              element: <CreateGroup />
            },
            {
              path: "create-users",
              element: <CreateUser />
            }
          ]
        },
        { path: "application-management", element: <ApplicationManagement /> },
        { path: "advanced-api-management", element: <AdvancedAPIManagement /> },
        { path: "authentication-settings", element: <AuthenticationSettings /> },
        { path: "account-settings", element: <AccountSettings /> }
      ]
    },
    {
      path: "landing",
      element: <LandingLayout />,
      children: [
        {
          path: "",
          element: <LandingPage />,
          index: true
        }
      ]
    },
    {
      path: "domain-setup",
      element: <CreateLayout />,
      children: [
        {
          path: "",
          element: <DomainSetup />,
          index: true
        },
        { path: "advanced", element: <AdvancedDomainSetup /> }
      ]
    },
    {
      element: <BlankLayout />,
      children: [
        { path: "/", element: <LoginPage />, index: true },
        { path: "reset", element: <ResetPassword /> },
        { path: "forget-password", element: <ForgetPassword /> },
        { path: "authenticator", element: <Authenticator /> },
        { path: "mobile-otp", element: <MobileOTP /> },
        { path: "email-otp", element: <EmailOTP /> },
        { path: "apps", element: <ProductPage /> },
        { path: "unauthorized", element: <UnauthorizedPage /> },
        { path: "verify-email", element: <VerifyEmail /> }
      ]
    }
  ]);

  return routes;
}
